import {
  ErrorMessage,
  Field,
  FieldProps,
  FormikErrors,
  FormikTouched,
} from "formik";
import { SelectWrapper } from "../../../../../components/general/SelectWrapper";
import { Text } from "../../../../../components/general/Text";
import { INACTIVATION_REASONS } from "../../../../../domains/Student";
import styleVariables from "../../../../../styles/variables.scss";
import styles from "../styles.scss";
import { StudentInactivationReason } from "../UploadForm/useImportStudentPasscodeInactivation";

export type Values = { reason: StudentInactivationReason | "" };

type Props = {
  errors: FormikErrors<Values>;
  touched: FormikTouched<Values>;
  setFieldValue: (field: string, value: any) => void;
  setFieldTouched: (field: string, touched: boolean) => void;
};

const selectedReasonOption = (value: string) => {
  const selectedReason = INACTIVATION_REASONS.find((r) => r.type === value);
  if (!selectedReason) {
    return null;
  }
  return { label: selectedReason.label, value: selectedReason.type };
};

export const InactivationReasonSelector = ({
  errors,
  touched,
  setFieldValue,
  setFieldTouched,
}: Props) => {
  return (
    <div className="px-8 mb-8">
      <Text size="md" className="mb-3">
        「停止」のご理由を選択の上、「連携を停止」を押してください。
      </Text>
      <Field name="reason">
        {({ field }: FieldProps) => (
          <SelectWrapper
            options={INACTIVATION_REASONS.map((reason) => ({
              label: reason.label,
              value: reason.type,
            }))}
            value={selectedReasonOption(field.value)}
            onChange={(option) => setFieldValue("reason", option?.value || "")}
            onBlur={() => setFieldTouched("reason", true)}
            placeholder="停止理由を選択してください"
            hasError={!!(errors.reason && touched.reason)}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            styles={{
              menuPortal: (base) => ({
                ...base,
                zIndex: styleVariables.zIndexOverlay,
              }),
            }}
          />
        )}
      </Field>
      <ErrorMessage name="reason">
        {(msg) => <div className={styles.errorMessage}>{msg}</div>}
      </ErrorMessage>
    </div>
  );
};
